import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentPlaceholderComponent } from './content-placeholder.component';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    ContentPlaceholderComponent
  ],
  imports: [
    CommonModule,
    IonicModule, 
    ComponentsModule
  ]
})
export class ContentPlaceholderModule { }
